module.exports = "/_next/static/resources/single-a18511220c96ac1bcaa6b5eae433018d.jpg";